import { createContext } from "react";

export const WeightContext = createContext({
  weights: [],
  weight: {},
});
